import { StylesConfig } from 'react-select';
import styled from 'styled-components';
import { BasePanel } from 'styles/components';
import { Colors } from 'styles/constants';
import { DefaultSelectStyle } from 'components/Shared/Forms/Select/styles';

interface AreaOption {
  value: number;
  label: string;
}

const baseSelectStyle = DefaultSelectStyle as StylesConfig<AreaOption, true>;

export {
  ActivityIndicator,
  Button,
  OperationIcon as AreaIcon,
} from 'styles/components';

export const MainPanel = styled(BasePanel)`
  flex: 0 1 100%;
  flex-direction: column;
  background: ${Colors.White};
  padding: 24px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  > * {
    flex: 1;
  }
`;

export const AreaSelectStyle: StylesConfig<AreaOption, true> = {
  ...baseSelectStyle,
  container: (base, state) => ({
    ...(baseSelectStyle.container?.(base, state) ?? base),
    height: 'auto',
    minHeight: '3rem',
  }),
  control: (base, state) => ({
    ...(baseSelectStyle.control?.(base, state) ?? base),
    height: 'auto',
    minHeight: '3rem',
    boxShadow: state.isFocused ? `0 0 0 2px ${Colors.Orange}` : 'none',
    overflow: 'hidden',
  }),
  valueContainer: (base, state) => ({
    ...(baseSelectStyle.valueContainer?.(base, state) ?? base),
    flexWrap: 'wrap',
    overflow: 'hidden',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 100 }),
};
